"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var FinanceSummaryBlocksStaticContent_1 = require("../../StaticContent/FinanceSummaryBlocksStaticContent");
var MultiCurrencyFinanceRatesBlock_1 = require("./rates/MultiCurrencyFinanceRatesBlock");
var MultiCurrencyFinanceSummaryBlock = function (_a) {
    var financeDetails = _a.financeDetails, showTitle = _a.showTitle, isMultiCurrency = _a.isMultiCurrency, isError = _a.isError, totalPayable = _a.totalPayable, disclaimerText = _a.disclaimerText;
    return (<core_1.Box data-test="finance_summary:container:multi_currency">
    <FinanceSummaryBlocksStaticContent_1.default showTitle={showTitle} isError={isError}>
      <MultiCurrencyFinanceRatesBlock_1.default {...{ financeDetails: financeDetails, isMultiCurrency: isMultiCurrency, totalPayable: totalPayable, disclaimerText: disclaimerText }}/>
    </FinanceSummaryBlocksStaticContent_1.default>
  </core_1.Box>);
};
exports.default = MultiCurrencyFinanceSummaryBlock;
